// extracted by mini-css-extract-plugin
export var blue = "_14-g";
export var brand = "_14-c";
export var darkGrey = "_14-f";
export var disabled = "_14-6";
export var disabledSubtle = "_14-7";
export var error = "_14-8";
export var green = "_14-h";
export var grey = "_14-e";
export var icon = "_14-0";
export var inherit = "_14-b";
export var lightGrey = "_14-d";
export var orange = "_14-j";
export var pink = "_14-l";
export var primary = "_14-1";
export var purple = "_14-m";
export var quaternary = "_14-4";
export var quinary = "_14-5";
export var red = "_14-k";
export var secondary = "_14-2";
export var success = "_14-a";
export var tertiary = "_14-3";
export var warning = "_14-9";
export var white = "_14-n";
export var yellow = "_14-i";